<template>
    <span>
        <el-popover placement="bottom-start"
                    trigger="click" min-width="500" v-if="fileList.length > 0" v-model="visible">
            <el-table :data="fileList" fit stripe :show-header="false">
                <el-table-column property="name" label="名称" width="280">
                    <template slot-scope="scope">
                        <!-- <span class="text-link" v-preview="'http://127.0.0.1'+scope.row.url" :alt="scope.row.name"
                              preview-title-enable="true" preview-nav-enable="true">{{ scope.row.name }}</span> -->
                              <span class="text-link" v-preview="scope.row.url" :alt="scope.row.name"
                                    preview-title-enable="true"
                                    preview-nav-enable="true"
                                    v-show="!isPdfFile(scope.row.name)">{{scope.row.name}}</span>
                              <span class="text-link" @click="previewPdf(scope.row)"
                                    v-show="isPdfFile(scope.row.name)" >{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="name" label="文件大小">
                    <template slot-scope="scope">
                        <span>{{ scope.row.size | formatSize }}</span>
                    </template>
                </el-table-column>
                <el-table-column property="operation" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                            <el-button size="mini"
                                       v-show="allowDelete"
                                       type="text"
                                       @click="handleDelete(scope.row)"><i class="el-icon-delete"></i></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="下载" placement="top-start">
                            <el-button size="mini" type="text"
                                       @click="download(scope.row)"><i class="el-icon-download"></i></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <span class="text-link font-weight-bold" slot="reference">{{ attachmentName }}</span>
        </el-popover>
        <el-tooltip effect="light" content="下载全部文件" placement="top-start">
            <el-button class="ml-2" type="text" v-if="fileList.length > 0"
                       @click="downloadListByObject(objectType, objectId, attachmentName)"><i class="el-icon-download"></i></el-button>
        </el-tooltip>
        <el-dialog :title="pdfname" :visible.sync="previewVisible">
          <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
        </el-dialog>
    </span>
</template>

<script>
  import {download, downloadListByObject} from "@/utils";
  import checkPermission from "@/utils/permission";
  import {removeFile} from "@/api/upload";
  import {formatSize} from "@/utils/misc";
  import VuePdfPreview from "@/components/VuePdfPreview"

  export default {
    name: "index",
    components: {
      VuePdfPreview
    },
    props: {
      objectType: {
        type: String,
        required: true
      },
      objectId: {
        type: [Number, String],
        required: true
      },
      fileList: {
        type: Array,
        required: true
      },
      attachmentName: {
        type: String,
        required: true
      },
      allowDelete: {
        type: Boolean,
        default: true
      }
    },
    filters: {
      formatSize
    },
    data() {
      return {
        pdfUrl: '',
        visible: false,
        previewVisible:false,
        pdfname:'',
      }
    },
    methods: {
      checkPermission,
      download,
      downloadListByObject,
      previewPdf(file){
        // window.open(url, 'PDF', '')
        console.log(file.url)
        this.pdfname = file.name
        this.pdfUrl = file.url
        this.previewVisible = true
      },
      isPdfFile(filename) {
        var is_pdf = false;
        //获取最后一个.的位置
        var index = filename.lastIndexOf(".");
        //获取后缀
        var ext = filename.substr(index+1);
        //判断是否pdf
        if (['pdf'].indexOf(ext.toLowerCase()) !== -1) {
          is_pdf = true
        }
        return is_pdf
      },
      handleDelete(file) {
        removeFile(file.id)
          .then(() => {
            this.$emit("removed");
          })
          .catch(error => {
            this.$message.error(error)
          });
      }
    }
  };
</script>

<style scoped>
</style>
